import { Injectable } from '@angular/core';
import { now } from "moment";
import { AngularFirestore } from 'angularfire2/firestore';
import * as moment from 'moment';
import firebase from 'firebase/app';

@Injectable()
export class FirestoreProvider {
  constructor(public firestore: AngularFirestore) {}

  createStudy(doctor, patient, study, signatoryname, signature, consentname, consent_signature, speedscore, studydata): Promise<void> {
    const id = this.firestore.createId();
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    let date: moment.Moment = moment();
    studydata['doctor'] = doctor;
    studydata['patient'] = patient;
    studydata['study'] = study;
    studydata['agreement'] = {
      'signatory_name': signatoryname,
      'signature': signature,
      'consent_name': consentname,
      'consent_signature': consent_signature
    }
    studydata['Renewed'] = false;
    studydata['doctor_id'] = doctor['id'];
    studydata['patient_id'] = patient['id'];
    studydata['clinic_id'] = doctor['clinic_id'];
    studydata['speedscore'] = speedscore;
    studydata['createdAt'] = timestamp;
    return this.firestore.doc(`studyresults/${id}`).set(studydata);
  }

  updateStudy(id, renewed) {
    console.log("ID: ", id);
    console.log("Renewed: ", renewed)
    return this.firestore.doc(`studyresults/${id}`).update({
        "Renewed": renewed
    });
  }

  getStudiesByClinic(clinicid)  {
    return this.firestore.collection('studyresults', ref => ref.where('clinic_id', '==', clinicid).orderBy('createdAt'))
  }

  getStudiesByClinicFollowUp(clinicid)  {
    let dueDate: moment.Moment = moment();
    dueDate = dueDate.add(-10, "M");
    return this.firestore.collection('studyresults', ref => ref.where('clinic_id', '==', clinicid).where('Renewed', '==', false).where('createdAt', '<', dueDate.toDate()).orderBy('createdAt'))
  }

  getStudiesByPatient(patientid)  {
    //return this.firestore.collection('studyresults', ref => ref.where('patient_id', '==', patientid))
    return this.firestore.collection('studyresults', ref => ref.where('patient_id', '==', patientid).limit(1));
  }

  getMedsByClinic(clinic_id)  {
    //return this.firestore.collection('studyresults', ref => ref.where('patient_id', '==', patientid))
    return this.firestore.collection('clinic/' + clinic_id + '/medications');
  }

  savePrescription(prescription)  {
    const id = this.firestore.createId();
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    let date: moment.Moment = moment();
    prescription['doctor_id'] = prescription.doctor[0]['id'];
    prescription['patient_id'] = prescription.patient['id'];
    prescription['clinic_id'] = prescription.doctor[0]['clinic_id'];
    prescription['createdAt'] = timestamp;
    return this.firestore.doc(`prescriptions/${id}`).set(prescription);
  }

  getPrescriptionsByClinic(clinicid)  {
    return this.firestore.collection('prescriptions', ref => ref.where('clinic_id', '==', clinicid).orderBy('createdAt'))
  }
}


// WEBPACK FOOTER //
// ./src/providers/firestore/firestore.ts